export const TransactionalSaleFormTabs = {
  WHO: "Who",
  WHAT: "What",
  WHEN: "When",
  PRICE: "Price",
  NLIS: "NLIS",
  REVIEW: "Review",
} as const;

export type TransactionalSaleFormTabId =
  (typeof TransactionalSaleFormTabs)[keyof typeof TransactionalSaleFormTabs];

export const saleNamespace = "sale";
export const consignmentNamespace = "consignment";
export const saleLotNamespace = "saleLot";
export const skinLotsNamespace = "skinLots";
